import uav from "../../../assets/img/map/icon/uav.png";
import routePoint from "../../../assets/img/map/route/routePoint.png";
import endPoint from "../../../assets/img/map/route/endPoint.png";

var airspaceStyle = {};

//openlayers中描绘 无人机样式
airspaceStyle.uavStyle = {
    src: uav,
    textColor: 'rgba(255,255,255,1)',
    textSize: 10
};

//航迹航线
airspaceStyle.routeStyle = {
    strokeColor: '#244975',
    strokeWeight: 3,
    strokeStyle: "solid",
    // strokeColorRgba: 'rgba(36,73,117,1)',
    strokeColorRgba: 'rgba(36,73,117,0.5)',
    lineDash: [1, 1]
};

//规划航迹样式
airspaceStyle.taskPlanRouteStyle = {
    strokeColor: '#FFFFFF',
    strokeWeight: 3,
    strokeStyle: "solid",
    strokeColorRgba: 'rgba(0,131,253,1)',
};

//飞行记录规划航线样式
airspaceStyle.flightRecordRouteStyle = {
    strokeColor: '#FFFFFF',
    strokeWeight: 3,
    strokeStyle: "solid",
    strokeColorRgba: 'rgba(255,255,255,1)',
};

//规划航迹点样式
airspaceStyle.taskPlanRoutePointStyle = {
    src: routePoint
}

//飞行记录规划航迹点起点样式
airspaceStyle.flightRecordRouteStartPointStyle = {
    src: routePoint
}
//飞行记录规划航迹点终点样式
airspaceStyle.flightRecordRouteEndPointStyle = {
    src: endPoint
}

/*空域颜色*/
//危险区
airspaceStyle.daiwColor = {
    strokeWeight: 2,
    fillColorRgba: 'rgba(255, 166, 62, 0.3)',
    strokeColorRgba: 'rgba(255, 166, 62, 1)'
};

//临时飞行区
airspaceStyle.erailColor = {
    strokeWeight: 2,
    fillColorRgba: 'rgba(42, 198, 146, 0.3)',
    strokeColorRgba: 'rgba(42, 198, 146, 1)'
};

//禁区
airspaceStyle.forbidColor = {
    strokeWeight: 2,
    fillColorRgba: 'rgba(247, 67, 71, 0.3)',
    strokeColorRgba: 'rgba(247, 67, 71,1)'
};

//限制区
airspaceStyle.restrictColor = {
    strokeWeight: 2,
    fillColorRgba: 'rgba(181, 127, 220, 0.3)',
    strokeColorRgba: 'rgba(181, 127, 220, 1)'
};

//净空区
airspaceStyle.cleanColor = {
    strokeWeight: 2,
    fillColorRgba: 'rgba(123, 181, 255, 0.3)',
    strokeColorRgba: 'rgba(123, 181, 255, 1)'
}; /*空域颜色*/

export default airspaceStyle;


// WEBPACK FOOTER //
// ./src/assets/js/map/airspaceStyle.js